<!--佣金查询-->
<template>
  <div class="CommissionQuery">
    <app-breadcrumb />
    <div class="page-container">
      <div class="filter">
        <el-form :inline="true" :model="listQuery" label-width="80px" size="mini">
          <!--期数-->
          <el-form-item :label="$t('PoOrder.periodWeek')">
              <!-- 期数起始 -->
              <el-select
                  v-model="listQuery.fromWeek"
                  v-loading="wWeekLoading"
                  :placeholder="this.$t('Start.Period')"
                  filterable
                  style="width: 120px;"
                  clearable
              >
                <el-option v-for="role in listdata" :key="role.id" :label="role.wWeek" :value="role.wWeek" />
              </el-select>
              &nbsp;&nbsp; - &nbsp;&nbsp;
              <!-- 期数结束 -->
              <el-select
                  v-model="listQuery.toWeek"
                  v-loading="wWeekLoading"
                  filterable
                  style="width: 120px;"
                  :placeholder="this.$t('End.Period')"
                  clearable
              >
                <el-option v-for="role in listdata" :key="role.id" :label="role.wWeek" :value="role.wWeek" />
              </el-select>
          </el-form-item>
          <!--总佣金-->
         <el-form-item :label="$t('bd.salaryAll')">
              <el-select v-model="listQuery.bonusAll" style="width: 100px;">
                <el-option value="" />
                <el-option v-for="i in typecompare" :key="i.code" :label="$t(i.title)" :value="i.code" />
              </el-select>
              <el-input v-model.trim="listQuery.bonusAll" style="width: 150px" clearable />
          </el-form-item>
          <el-form-item style="margin-left:10px;">
            <el-button :loading="btnLoading" type="primary" plain icon="el-icon-search" @click="handleFilter">{{ this.$t('operation.button.search') }}</el-button>
          </el-form-item>
        </el-form>
      </div>
      <el-table v-loading="loading" :data="list" style="width: 100%" size="mini" border fit stripe>
        <!--期次-->
        <el-table-column :label="$t('PoOrder.periodWeek')" prop="wWeek" align="center" />
        <!--姓名-->
        <el-table-column :label="$t('person.name')" prop="name" align="center" />
        <!--荣衔-->
        <el-table-column :label="$t('mi.honourLevel')" align="center">
          <template v-slot="{row}">
            {{ $lt('cn.mimember.cardtype', row.newCardType) }}
          </template>
        </el-table-column>
        <!--级别-->
        <el-table-column :label="$t('commond.levelType')" align="center">
        <template v-slot="{row}">
          {{ $lt('cn.member.level', row.newLevelType) }}
        </template>
      </el-table-column>
        <!--个人业绩-->
        <el-table-column :label="$t('mimember.onesell')" prop="perSellLocal" align="center" />
        <!--重销业绩-->
        <el-table-column :label="$t('miagent.sell.consal')" prop="consumSellLocal" align="center" />
        <!--市场业绩-->
        <el-table-column :label="$t('mi.member.perSell')" prop="pointAdd" align="center" />
        <!--A-->
        <el-table-column label="A" prop="pointA" align="center" />
        <!--B-->
        <el-table-column label="B" prop="pointB" align="center" />
        <!--C-->
        <el-table-column label="C" prop="pointC" align="center" />
        <!--D-->
        <el-table-column label="D" prop="pointD" align="center" />
        <!--重销保留-->
        <el-table-column :label="$t('miagent.keep.consal')" prop="lastConSell" align="center" />
        <!--大边保留-->
        <el-table-column :label="$t('bd.point.keep.bigside')" prop="bigLastPoint" align="center" />
        <!--永续服务奖-->
        <el-table-column :label="$t('bonus.bonusService')" prop="bonusService" align="center" />
        <!--市场开拓奖-->
        <el-table-column :label="$t('bonus.bonusMarket')" prop="bonusMarket" align="center" />
        <!--重销奖-->
        <el-table-column :label="$t('bonus.bonusConsum')" prop="bonusAgsell" align="center" />
        <!--菁英奖-->
        <el-table-column :label="$t('bd.elite.award')" prop="bonusCash" align="center" />
        <!--钻石分红-->
        <el-table-column :label="$t('bd.share.diamond')" prop="bonusShare1" align="center" />
        <!--总佣金-->
        <el-table-column :label="$t('bd.salaryAll')" prop="bonusAll" align="center" />
      </el-table>
      <pagination :total="total" :page.sync="listQuery.page" :limit.sync="listQuery.limit" @pagination="getList" />
    </div>
  </div>
</template>

<script>
import Pagination from '@/components/Pagination'
import {bdBonusHisMemChinas} from "@/api/ay-personal-center/personalcenter"
// import {getwWeek} from '@/api/home'
export default {
  name: 'CommissionQuery',
  components: { Pagination },
  data() {
    return {
      btnLoading: false,
      wWeekLoading:false,
      loading: false,
      listdata: [],
      list: [],
      total: 0,
      listQuery: {
        page: 1,
        limit: 10,
        fromWeek: '',
        toWeek: ''
      },
      initDict:{
        typecompare:'type.compare'
      }
    }
  },
  computed:{
    typecompare(){
      return this.$ll(this.initDict.typecompare)
    }
  },
  created() {
    this.getWeeks()
    this.listdata = JSON.parse(sessionStorage.getItem('wWeekLocalList'))
  },
  methods: {
    getList() {
      this.listLoading = true
      this.btnLoading = true
      bdBonusHisMemChinas({...this.listQuery}).then(res => {
        this.list = res.data.records
        this.total = +res.data.total
        this.listLoading = false
        this.btnLoading = false
      }).catch(() => {
          this.$message.error(this.$t('Query_failed')) // 查询失败
          this.listLoading = false
          this.btnLoading = false
      })
    },
    // 查询
    handleFilter() {
      this.getList()
    },
    // 期次
    getWeeks() {
      // this.WeekList = JSON.parse(sessionStorage.getItem('wWeekLocalList'))
      // this.wWeekLoading = true
      // this.btnLoading = true
      // getwWeek().then(res => {
      //   this.listdata = res.data
      //   this.listQuery.fromWeek = res.data[0].chinaWWeek
      //   this.listQuery.toWeek = res.data[0].chinaWWeek
      //   this.wWeekLoading = false
      //   this.btnLoading = false
      // })
    },
  }
}
</script>

<style>

</style>
